import React, { useMemo } from 'react';
import { getVideoEmbedConfig } from '../utils/demoVideo';

export default function DemoVideoPlayer({ src, title, autoPlay = false, className = '' }) {
  const config = useMemo(() => getVideoEmbedConfig(src, autoPlay), [src, autoPlay]);

  if (config.type === 'iframe') {
    return (
      <iframe
        className={className}
        src={config.embedUrl}
        title={title}
        loading="lazy"
        allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
        allowFullScreen
        referrerPolicy="strict-origin-when-cross-origin"
      />
    );
  }

  return (
    <video
      className={className}
      src={config.sourceUrl}
      controls
      playsInline
      preload="metadata"
      autoPlay={autoPlay}
    />
  );
}
